import { MenuItem } from '@mui/material';
import { TextField } from '@side/pantry';
import {
  type Control,
  Controller,
  type FieldValues,
  type Path,
} from 'react-hook-form';
import { CUSTOM_RANGE_LABEL } from '@/constants';
import {
  REPORTING_PERIOD_ALL_TIME,
  REPORTING_PERIOD_CUSTOM,
  REPORTING_PERIOD_L365,
} from '../types';

interface Props<T extends Record<string, unknown>> {
  control: Control<T, unknown, T>;
  name: Path<T>;
  startDate?: string;
}

export const CloseDateFilter = <T extends FieldValues>({
  control,
  name,
  startDate,
}: Props<T>) => {
  const currentYear = new Date().getFullYear();

  const initialYear = startDate
    ? new Date(startDate).getFullYear()
    : currentYear;

  const years = Array.from(
    { length: currentYear - initialYear },
    (_, index) => initialYear + index,
  ).sort((a, b) => b - a);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <TextField
          {...field}
          select
          label="Close Date"
          fullWidth
          value={field.value}
          onChange={field.onChange}
        >
          <MenuItem value={currentYear}>YTD {currentYear}</MenuItem>
          {years.map((year) => (
            <MenuItem key={year} value={year}>
              Year {year}
            </MenuItem>
          ))}
          <MenuItem value={REPORTING_PERIOD_L365}>Last 365</MenuItem>
          {startDate && (
            <MenuItem value={REPORTING_PERIOD_ALL_TIME}>All Time</MenuItem>
          )}
          <MenuItem value={REPORTING_PERIOD_CUSTOM}>
            {CUSTOM_RANGE_LABEL}
          </MenuItem>
        </TextField>
      )}
    />
  );
};
